import { PicturePack } from "@tblabs/storage";
import { Collection, Image } from "@tblabs/truffle";
import { Row } from "./Utils/Row";


export class PicturesGallery extends Row
{
    constructor(pictures: Collection<PicturePack>)
    {
        super(
            ...pictures.Items.map(picture =>
                new Image(picture.Files["thumbnail"])
                    .OnClick(() => window.open(picture.Files["big"] || picture.Files["source"], "_blank"))
            ));

        this.Class("pictures-gallery");
    }
}
